module.exports = __webpack_public_path__ + "static/media/no-tail-arrow-down.04e5f711.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/no-tail-arrow-down.svg
 ** module id = 179
 ** module chunks = 0
 **/